<template>
	<div class="pt-2">
		<CommonFlame :title="title" :maxWidth="'800px'">
			<v-row no-gutters justify="end">
				<v-btn color="secondary" @click="submitForm()">
					<v-icon class="mr-1"> mdi-content-save-outline </v-icon>
					保存する
				</v-btn>
				<v-btn class="ml-2" color="secondary" @click="renderToShowPage()">
					<v-icon class="mr-1"> mdi-file-document-outline </v-icon>
					注文書発行
				</v-btn>
			</v-row>
			<ValidationError :errors="errors" />
			<v-form ref="form" v-model="valid" class="mt-4">
				<table width="100%" class="show-dialog-table show-dialog-table--form">
					<tbody>
						<tr>
							<th class="bg-white font-weight-bold">基本情報</th>
						</tr>
						<ShowDetailRecord :columnName="'発注先'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo1"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'注文日'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo2"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<tr>
							<th class="bg-white font-weight-bold">内容</th>
						</tr>
					</tbody>
					<!--TODO  v-for -->
					<tbody>
						<ShowDetailRecord :columnName="'注文項目'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo3"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'注文概要'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo4"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'単価'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo5"
									background-color="white"
									dense
									outlined
									:rules="[rules.integer]"
									suffix="円"
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'数量'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo6"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'単位'">
							<template v-slot:value>
								<v-text-field
									v-model="outsourcing_worker_arrangement.todo7"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
				<v-btn class="mt-4" @click="addOrderItem()" color="secondary">
					<v-icon class="mr-1">mdi-plus</v-icon>
					内容を追加する
				</v-btn>
			</v-form>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import ValidationError from "../shared/ValidationError.vue"

export default {
	components: {
		CommonFlame,
		ShowDetailRecord,
		ValidationError,
	},
	data() {
		return {
			title: "注文内容編集",
			id: this.$route.params.id,
			outsourcing_worker_arrangement: {
				todo1: "株式会社 XXXXX",
				todo2: "2023-05-01",
				todo3: "XX XX",
				todo4: "作業期間：XXXX/XX/XX ～ XXXX/XX/XX",
				todo5: null,
				todo6: null,
				todo7: "式",
				order_items: {
					// 仮のカラム名
				},
			},
			errors: [],
			valid: false,
			rules,
		}
	},

	mounted() {
		this.fetchEditData()
	},
	methods: {
		fetchEditData() {
			// TODO
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/outsourcing_worker_arrangements/${this.id}/edit`
			axios
				.get(url, { headers })
				.then((res) => {
					this.outsourcing_worker_arrangements = res.data.outsourcing_worker_arrangement
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		addOrderItem() {},
		submitForm() {
			// TODO
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/outsourcing_worker_arrangements/${this.id}`
			const params = { outsourcing_worker_arrangement: this.outsourcing_worker_arrangement }
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		renderToShowPage() {},
	},
}
</script>
